/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeurekaHostNameApiKeyData
 */
export interface HeurekaHostNameApiKeyData {
    /**
     * Project domain connected to the Heureka shop.
     * @type {string}
     * @memberof HeurekaHostNameApiKeyData
     */
    hostName?: string;
    /**
     * Heureka conversion measurement reports API key.
     * @type {string}
     * @memberof HeurekaHostNameApiKeyData
     */
    apiKey?: string;
}

/**
 * Check if a given object implements the HeurekaHostNameApiKeyData interface.
 */
export function instanceOfHeurekaHostNameApiKeyData(value: object): value is HeurekaHostNameApiKeyData {
    return true;
}

export function HeurekaHostNameApiKeyDataFromJSON(json: any): HeurekaHostNameApiKeyData {
    return HeurekaHostNameApiKeyDataFromJSONTyped(json, false);
}

export function HeurekaHostNameApiKeyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeurekaHostNameApiKeyData {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
    };
}

export function HeurekaHostNameApiKeyDataToJSON(json: any): HeurekaHostNameApiKeyData {
    return HeurekaHostNameApiKeyDataToJSONTyped(json, false);
}

export function HeurekaHostNameApiKeyDataToJSONTyped(value?: HeurekaHostNameApiKeyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
        'apiKey': value['apiKey'],
    };
}

